import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Intro } from './intro';
import { MapCanvas } from './map-canvas';
import { Sidebar } from './sidebar';

let App = class App extends React.PureComponent {
  render() {
    const { intro, geojson, activeFeature, mapResult, error } = this.props;
    return (
      <div>
        {intro ? (
          <Intro geojson={geojson} error={error} />
        ) : (
          <div className="flex-parent viewport-full scroll-hidden">
            <div className="flex-child w360 h-full shadow-darken10 z1">
              <Sidebar
                geojson={geojson}
                mapResult={mapResult}
                activeFeature={activeFeature}
              />
            </div>
            <div className="flex-child flex-child--grow">
              <MapCanvas mapResult={mapResult} activeFeature={activeFeature} />
            </div>
          </div>
        )}
      </div>
    );
  }
};

App.propTypes = {
  error: PropTypes.string,
  mapResult: PropTypes.object,
  activeFeature: PropTypes.object,
  geojson: PropTypes.object.isRequired,
  intro: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return state;
}

App = connect(mapStateToProps)(App);

export { App };
